module.exports = __webpack_public_path__ + "static/gate2-4c1f513a149edcefc083556fbce2d037.jpg";